import React from 'react';

const KnowledgeBaseSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      className={className}
    >
      <path
        d="M11.1469 4.8501H9.04688"
        stroke={color}
        strokeWidth="1.2"
        strokeWidth="round"
      />
      <path
        d="M3.10156 3.25214C3.10156 2.85058 3.10156 2.64981 3.13555 2.48257C3.28514 1.74634 3.90532 1.17046 4.69817 1.03156C4.87828 1 5.0945 1 5.52694 1C5.71641 1 5.81114 1 5.90219 1.0079C6.29472 1.04199 6.66708 1.1852 6.9706 1.41883C7.04095 1.47303 7.10794 1.53523 7.24192 1.65964L7.51156 1.91C7.91126 2.28118 8.11118 2.46677 8.35051 2.59042C8.48197 2.65834 8.62141 2.71198 8.7661 2.75028C9.02951 2.82 9.31217 2.82 9.87749 2.82H10.0606C11.3504 2.82 11.9954 2.82 12.4146 3.17011C12.4531 3.20231 12.4898 3.23639 12.5245 3.27219C12.9016 3.66146 12.9016 4.26032 12.9016 5.45805V6.46C12.9016 8.17591 12.9016 9.0339 12.3275 9.56695C11.7534 10.1 10.8295 10.1 8.98156 10.1H7.02156C5.17365 10.1 4.2497 10.1 3.67563 9.56695C3.10156 9.0339 3.10156 8.17591 3.10156 6.46V3.25214Z"
        stroke={color}
        strokeWidth="1.2"
      />
      <path
        d="M15 13.6001H9.4M1 13.6001H6.6"
        stroke={color}
        strokeWidth="1.2"
        strokeWidth="round"
      />
      <path
        d="M8 12.2001V10.1001"
        stroke={color}
        strokeWidth="1.2"
        strokeWidth="round"
      />
      <path
        d="M8.00156 15C8.77476 15 9.40156 14.3731 9.40156 13.6C9.40156 12.8268 8.77476 12.2 8.00156 12.2C7.22836 12.2 6.60156 12.8268 6.60156 13.6C6.60156 14.3731 7.22836 15 8.00156 15Z"
        stroke={color}
        strokeWidth="1.2"
      />
    </svg>
  );
};

export default KnowledgeBaseSVG;
